import * as React from 'react';
import Form from 'react-bootstrap/Form';
import LookupValueSelectList from '../LookupValueSelectList/LookupValueSelectList';
import { LookupValueTypes } from '../LookupValueSelectList/lookupValueTypes';
import { IWorkflowExecute, IWorkflowStep } from './business-objects/common';
import SelectList from '../RBSelectList/RBSelectList';
import { Button } from 'react-bootstrap';

export interface IWorkflowExecuteProps {
  execute: IWorkflowExecute;
  idx: number;
  steps: IWorkflowStep[];
  handleExecuteChange: (
    e: React.FormEvent,
    execute: IWorkflowExecute,
    dataField: string
  ) => void;
  removeTriggerExecute: (id: number) => void;
}

export default class WorkflowExecute extends React.Component<
  IWorkflowExecuteProps
> {
  renderExecuteValues(typeId: string) {
    switch (typeId) {
      case '-1':
        return (
          <Form.Group>
            <Form.Label>
              <strong>Route To Step</strong>
            </Form.Label>
            {this.props.steps && this.props.steps.length > 0 && (
              <SelectList
                key={`routeto${this.props.execute.id}`}
                data={this.props.steps.map((x) => {
                  return { name: x.name, value: x.id };
                })}
                value={
                  this.props.execute.executeValue ||
                  this.props.steps[0].id.toString()
                }
                onChange={(e) =>
                  this.props.handleExecuteChange(e, this.props.execute, 'value')
                }
                datafield='executeValue'
              />
            )}
          </Form.Group>
        );
      case '-2':
        return (
          <Form.Group>
            <Form.Label>
              <strong>Notify</strong>
            </Form.Label>
            <Form.Control
              key={`notify${this.props.execute.id}`}
              type='text'
              onChange={(e) =>
                this.props.handleExecuteChange(e, this.props.execute, 'value')
              }
              value={this.props.execute.executeValue || ''}
              data-field='executeValue'
            />
          </Form.Group>
        );
      case '-3': // complete report
      case '-4': // upload image ane keywords
      case '-5': // update keywords
      case '-6': // process auto-match
      case '-7': // release management holds
      case '-8': // send Redacted image to Law firm
      case '-9': // set step status to management
      case '-10':// send FrontSheet to OnBase
      case '-11':// upload RedactedImage to OnBase
      case '-12':// update spd to onbase
      case '-13':// process pending merge
        return '';
      default:
        return 'Not Configured';
    }
  }
  public render() {
    return (
      <React.Fragment>
        {this.props.idx > 0 ? 'AND' : <hr />}
        <i
          title='Remove Action'
          className='fas fa-ban pointer float-right'
          onClick={(e) =>
            this.props.removeTriggerExecute(this.props.execute.id)
          }
        ></i>
        <Form.Group>
          <Form.Label>
            <strong>Do This</strong>
          </Form.Label>
          <LookupValueSelectList
            key={`executeType${this.props.execute.id}`}
            onChange={(e) =>
              this.props.handleExecuteChange(e, this.props.execute, 'type')
            }
            datafield='executeType'
            value={this.props.execute.workflowExecuteTypeId.toString()}
            type={LookupValueTypes.BYNAME}
            typeName='WorkflowExecuteType'
            includeAll={false}
          />
        </Form.Group>
        {this.renderExecuteValues(
          this.props.execute.workflowExecuteTypeId.toString()
        )}
      </React.Fragment>
    );
  }
}
